module.exports = __webpack_public_path__ + "static/media/Cart.1f8141bf.svg";